import {Component, EventEmitter, Input, Output, ViewChild, OnInit} from '@angular/core';
import {ActivitySearchCriteria, GroupSearch} from '../../../../../models/group-search';
import {AchooSliderComponent} from '../../../../core/achoo-slider/achoo-slider.component';
import {CommonConstant} from '../../../../app.constants';
import {unescape} from 'querystring';
import {ActivityFilter} from '../../../../../models/filter-search';
import { ObjectUtils } from '../../../../utils/object.utils';

@Component({
  selector: 'activity-filters',
  templateUrl: './activity-filters.component.html',
  styleUrls: ['./activity-filters.component.scss']
})
export class ActivityFiltersComponent implements OnInit {
  @Input() filter: ActivityFilter;
  @Input() isActiveDiscoverFollower: boolean;

  @Output()
  public searchInfluencerByActivityEvent = new EventEmitter<ActivitySearchCriteria>();
  @Output()
  public clearActivityFilterEvent = new EventEmitter<ActivitySearchCriteria>();
  @Output()
  public hideActivityFilterEvent = new EventEmitter<any>();

  @ViewChild('reachRangeSlider')
  reachRangeSlider: AchooSliderComponent;
  @ViewChild('engagementRangeSlider')
  engagementRangeSlider: AchooSliderComponent;
  @ViewChild('impactRangeSlider')
  impactRangeSlider: AchooSliderComponent;
  @ViewChild('followerRangeSlider')
  followerRangeSlider: AchooSliderComponent;


  public activitySearchCriteria = new ActivitySearchCriteria();

  public minReach = 0;
  public maxReach = CommonConstant.MAX_REACH_FOLLOWER;
  public minEngagement = 0;
  public maxEngagement = CommonConstant.MAX_REACH_ENGAGEMENT;
  public minImpact = 0;
  public maxImpact: number;
  public minFollower = 0;
  public maxFollower = CommonConstant.MAX_REACH_FOLLOWER;

  ngOnInit(): void {
    this.maxImpact = this.isActiveDiscoverFollower ? CommonConstant.NEW_MAX_IMPACT : CommonConstant.OLD_MAX_IMPACT;
  }

  searchInfluencerByActivity() {
    const formattedCriteria = this.getFormattedSearchCriteria(this.activitySearchCriteria);
    this.searchInfluencerByActivityEvent.emit(formattedCriteria);
  }

  resetActivityFilters() {
    this.resetActivityUI();
    // emit event clear
    this.clearActivityFilterEvent.emit(this.activitySearchCriteria);
  }

  resetActivityUI() {
    // reset criteria
    this.activitySearchCriteria.selectedFollower = undefined;
    this.activitySearchCriteria.selectedImpact = undefined;
    this.activitySearchCriteria.selectedReach = undefined;
    this.activitySearchCriteria.selectedEngagement = undefined;
    // reset slider element
    this.reachRangeSlider.resetSlider();
    this.reachRangeSlider.sliderElement.reset();
    this.impactRangeSlider.resetSlider();
    this.impactRangeSlider.sliderElement.reset();
    if (this.isActiveDiscoverFollower) {
      this.followerRangeSlider.resetSlider();
      this.followerRangeSlider.sliderElement.reset();
    } else {
      this.engagementRangeSlider.resetSlider();
      this.engagementRangeSlider.sliderElement.reset();
    }
  }

  updateActivityUI(reachFrom, reachTo, secondFilterFrom, secondFilterTo, impactFrom, impactTo) {
    this.reachRangeSlider.updateRangeValue(reachFrom, reachTo);
    if (this.isActiveDiscoverFollower) {
      this.followerRangeSlider.updateRangeValue(secondFilterFrom, secondFilterTo);
    } else {
      this.engagementRangeSlider.updateRangeValue(secondFilterFrom, secondFilterTo);
    }
    this.impactRangeSlider.updateRangeValue(impactFrom, impactTo);
  }

  onClickedOutside(e) {
    const formattedCriteria = this.getFormattedSearchCriteria(this.activitySearchCriteria);
    this.hideActivityFilterEvent.emit(formattedCriteria);
  }

  get reachFrom() {
    return this.filter && this.filter.reachFrom > 0 ? this.filter.reachFrom : this.minReach;
  }

  get reachTo() {
    return this.filter && this.filter.reachTo > 0 ? this.filter.reachTo : this.maxReach;
  }

  get engagementFrom() {
    return this.filter && this.filter.engagementFrom > 0 ? this.filter.engagementFrom : this.minEngagement;
  }

  get engagementTo() {
    return this.filter && this.filter.engagementTo > 0 ? this.filter.engagementTo : this.maxEngagement;
  }

  get followerFrom() {
    return this.filter && this.filter.followerFrom > 0 ? this.filter.followerFrom : this.minFollower;
  }

  get followerTo() {
    return this.filter && this.filter.followerTo > 0 ? this.filter.followerTo : this.maxFollower;
  }

  get impactFrom() {
    return this.filter && this.filter.impactFrom > 0 ? this.filter.impactFrom : this.minImpact;
  }

  get impactTo() {
    return this.filter && this.filter.impactTo > 0 ? this.filter.impactTo : this.maxImpact;
  }

  private getFormattedSearchCriteria(searchCriteria) {
    let result = {...searchCriteria};

    // follower
    const selectedFollower = searchCriteria.selectedFollower;

    if (selectedFollower && selectedFollower.to === this.maxFollower) {
      result = {
        ...result,
        selectedFollower: {
          from: selectedFollower.from,
          to: null
        }
      };
    }

    // reach
    const selectedReach = searchCriteria.selectedReach;

    if (selectedReach && selectedReach.to === this.maxReach) {
      result = {
        ...result,
        selectedReach: {
          from: selectedReach.from,
          to: null
        }
      };
    }

    // impact
    const selectedImpact = searchCriteria.selectedImpact;

    if (selectedImpact && selectedImpact.to === this.maxImpact) {
      result = {
        ...result,
        selectedImpact: {
          from: selectedImpact.from,
          to: null
        }
      };
    }

    // engagement
    const selectedEngagement = searchCriteria.selectedEngagement;

    if (selectedEngagement && selectedEngagement.to === this.maxEngagement) {
      result = {
        ...result,
        selectedEngagement: {
          from: selectedEngagement.from,
          to: null
        }
      };
    }

    return ObjectUtils.deepClone(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/search-bar/activity-filters/activity-filters.component.ts